import type { TopbarStep } from "@typedefs/interfaces";
import { usePermissions } from "@app/hooks";
import LockBanner from "@components/lock/LockBanner";
import TopbarSteps from "./TopbarSteps";

interface TopbarProps {
	projectLabel?: string;
	activityLabel?: string;
	stepsList: TopbarStep[];
	isLoading?: boolean;
}

const BuilderTopbar = (props: TopbarProps) => {
	const { isPublic } = usePermissions();

	return (
		<div className="builder-top">
			<TopbarSteps {...props} isPublic={isPublic} />
			{!isPublic && <LockBanner />}
		</div>
	);
};

export default BuilderTopbar;